import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/multi-factor-authentication/multi-factor-authentication-constant';
import { InitiateAuthentication } from '../../../../models/multi-factor-authentication/multi-factor-authentication.interfaces';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { ApiBuilder, AppConfigService, handleError } from '../../../utils';
import { LoginRememberMeUtilsService } from '../../../../utils/login';
import { OauthAEMConfig } from '../../../../models/login';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';

@Injectable({
  providedIn: 'root'
})
export class InitiateAuthenticationService {
  initiateAuthenticationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.authenticate+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: LoginRememberMeUtilsService
  ) {}

  initiateAuthentication = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<InitiateAuthentication> => {
    const getInitiateAuthenticationUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const initiateAuthenticationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getInitiateAuthenticationUrl
      }
    ];

    return new ApiBuilder<undefined, InitiateAuthentication>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(initiateAuthenticationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.initiateAuthenticationHeader)
      .errorHandler(this._errorHandler)
      .library('INITIATE_AUTHENTICATION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
